import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home/Home/Home';
import NotFound from './components/SharedPage/NotFound/NotFound';
import Login from './components/Authentication/Login/Login';
import Register from './components/Authentication/Register/Register';
import Header from './components/SharedPage/Header/Header';
import Footer from './components/SharedPage/Footer/Footer';
import Blogs from './components/Blogs/Blogs/Blogs';
import About from './components/About/About/About';
import Services from './components/Services/Services/Services';
import ServiceBooked from './components/SharedPage/ServiceBooked/ServiceBooked';
import RequireAuth from './components/SharedPage/RequireAuth/RequireAuth';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/home' element={<Home></Home>}></Route>
        <Route path='/blogs' element={<Blogs></Blogs>}></Route>
        <Route path='/about' element={<About></About>}></Route>
        <Route path='/services' element={<Services></Services>}></Route>
        <Route path='/service/:serviceBookedId' element={
          <RequireAuth>
            <ServiceBooked></ServiceBooked>
          </RequireAuth>
        }></Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/register' element={<Register></Register>}></Route>
        <Route path='notFound' element={<NotFound></NotFound>}></Route>
        <Route path='*' element={<NotFound></NotFound>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;